export enum EpticaSelector {
  request_event_type_forwarded = 'request_event_type_forwarded',
  request_event_type_forwarded_by_agent_to_external_specialist = 'request_event_type_forwarded_by_agent_to_external_specialist',
  request_event_type_forwarded_with_attachments = 'request_event_type_forwarded_with_attachments',
  request_event_type_forwarded_by_agent_to_group = 'request_event_type_forwarded_by_agent_to_group',
  request_event_type_followup = 'request_event_type_followup',
  request_event_type_bounce_by_agent = 'request_event_type_bounce_by_agent',
  request_event_type_bounce_by_supervisor = 'request_event_type_bounce_by_supervisor',
  request_event_type_auto_forwarded = 'request_event_type_auto_forwarded',
  request_event_type_closure = 'request_event_type_closure',
  request_event_type_review_requested = 'request_event_type_review_requested',
  request_event_type_approved_by_supervisor = 'request_event_type_approved_by_supervisor',
  request_event_type_rejected_by_supervisor = 'request_event_type_rejected_by_supervisor',
  request_event_ask_for_help = 'request_event_ask_for_help',
  request_event_type_client_message = 'request_event_type_client_message',
  request_event_type_opening = 'request_event_type_opening',
  request_event_type_response = 'request_event_type_response',
  request_event_type_outgoing_mail = 'request_event_type_outgoing_mail',
  request_event_type_monitoring = 'request_event_type_monitoring',
}
